import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Text from '../../../base/Text/Text.js';
import { AWARD_CATEGORY_KEY, AWARD_COMPONENT_KEY } from '../Award.meta.js';

export default InjectedStyledComponent(Text, AWARD_CATEGORY_KEY, AWARD_COMPONENT_KEY, ['description']);
